import {
  openGlobalCashSession,
  getCurrentCashSession,
  closeGlobalCashSession,
  getCashSessionHistory,
  getZReportDetail,
} from "../../services/cashRegisterApi";

import {
  createCashRegisterSessionRuntime,
  createPOSActivitySessionBridge,
} from "../../engines/POSActivitySessionBridge";


/**
 * Retail POS Session Authority Runtime.
 *
 * This adapter owns no CashSession state.
 *
 * It only binds the existing cashRegisterApi authority to the
 * generic POSActivitySessionBridge contract.
 *
 * Authority:
 *
 *   cashRegisterApi
 *     ├── openGlobalCashSession
 *     ├── getCurrentCashSession
 *     ├── closeGlobalCashSession
 *     ├── getCashSessionHistory
 *     └── getZReportDetail
 *
 * No cash calculation is performed here.
 */
export function createRetailPOSSessionRuntime({
  openSession =
    openGlobalCashSession,

  resolveCurrentSession =
    getCurrentCashSession,

  closeSession =
    closeGlobalCashSession,

  getSessionHistory =
    getCashSessionHistory,

  getSessionReport =
    getZReportDetail,
} = {}) {
  return createCashRegisterSessionRuntime({
    openGlobalCashSession:
      openSession,

    getCurrentCashSession:
      resolveCurrentSession,

    closeGlobalCashSession:
      closeSession,

    getCashSessionHistory:
      getSessionHistory,

    getZReportDetail:
      getSessionReport,
  });
}


/**
 * Production-ready Retail POS Session Bridge.
 *
 * The returned bridge preserves company/activity scope while
 * delegating all CashSession operations to the existing
 * authoritative cash register runtime.
 */
export function createRetailPOSSessionBridge(
  options = {}
) {
  const sessionRuntime =
    createRetailPOSSessionRuntime(
      options
    );

  return createPOSActivitySessionBridge({
    sessionRuntime,
  });
}


export default createRetailPOSSessionBridge;
